import { BaseEnum } from "../BaseEnum";

export class DsrUploadedDocumentProcessStatus extends BaseEnum {
  static PENDING = 1;
  static PROCESSING = 2;
  static EXTRACTED = 3;
  static COMPLETED = 4;
  static FAILED = 5;

  static Codes = [
    this.PENDING,
    this.PROCESSING,
    this.EXTRACTED,
    this.COMPLETED,
    this.FAILED,
  ];

  static _labelKeys = [
    "enums.dsr-document-process-status.PENDING",
    "enums.dsr-document-process-status.PROCESSING",
    "enums.dsr-document-process-status.EXTRACTED",
    "enums.dsr-document-process-status.COMPLETED",
    "enums.dsr-document-process-status.FAILED",
  ];

  static getColor(code) {
    const colors = {
      [this.PENDING]: "grey",
      [this.PROCESSING]: "info",
      [this.EXTRACTED]: "info",
      [this.COMPLETED]: "success",
      [this.FAILED]: "error",
    };
    return colors[code] || "grey";
  }
}
